import { render } from "./SwitchLanguage.vue?vue&type=template&id=6cc739f6&scoped=true&ts=true"
import script from "./SwitchLanguage.vue?vue&type=script&lang=ts"
export * from "./SwitchLanguage.vue?vue&type=script&lang=ts"

import "./SwitchLanguage.vue?vue&type=style&index=0&id=6cc739f6&lang=scss&scoped=true"

import exportComponent from "/home/administrator/tourstat-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cc739f6"]])

export default __exports__